// 2026-09-07 — 안내 겹침 방지 게이트.
// 전면 안내(TierRolloutInterstitial, UserLayout)가 떠 있는 동안 홈의 다른 안내(첫 신청 튜토리얼 코치마크 · 신기능 코치마크 ·
// 승인 대기 바)가 시작하면 두 안내가 겹친다(2026-09-07 대표 실측: 신규 회원 전면 안내 위에 STEP 1/3 코치마크).
// 원칙 「한 화면에 안내는 하나」 — 전면 안내가 열려 있으면 다른 안내는 기다렸다가, 확인을 누른 뒤 같은 방문에서 이어서 시작한다.
// 컴포넌트 트리가 달라(UserLayout ↔ Home) props 로 못 넘기므로 모듈 저장소 + useSyncExternalStore 로 잇는다.
import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set();

export function setRolloutGateOpen(next) {
  const v = Boolean(next);
  if (v === open) return;
  open = v;
  listeners.forEach((fn) => {
    try { fn(); } catch { /* 무시 */ }
  });
}

export function isRolloutGateOpen() {
  return open;
}

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** 전면 안내가 지금 화면을 덮고 있나. true 인 동안 홈의 안내 자동 시작을 미룬다. */
export function useRolloutGateOpen() {
  return useSyncExternalStore(subscribe, isRolloutGateOpen, () => false);
}

/** 테스트용 초기화 */
export function _resetRolloutGate() {
  open = false;
  listeners.clear();
}
